import { Controller, useFormContext } from 'react-hook-form';

import { WAREHOUSE_STATUSES, type WarehouseCreateInput } from './schemas';

import { useClients } from '@/clients/queries';
import { FormField } from '@/components/form-field';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export interface WarehouseFormFieldsProps {
  mode: 'create' | 'edit';
}

export const WarehouseFormFields = ({ mode }: WarehouseFormFieldsProps) => {
  const { control } = useFormContext<WarehouseCreateInput>();
  const { data: clients } = useClients();

  return (
    <>
      {mode === 'create' ? (
        <div className="space-y-2">
          <Label>Клиент</Label>
          <Controller
            control={control}
            name="clientId"
            render={({ field, fieldState }) => (
              <>
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger>
                    <SelectValue placeholder="Выберите клиента…" />
                  </SelectTrigger>
                  <SelectContent>
                    {(clients ?? []).map((c) => (
                      <SelectItem key={c.id} value={c.id}>
                        {c.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {fieldState.error ? (
                  <p className="text-xs text-destructive">{fieldState.error.message}</p>
                ) : null}
              </>
            )}
          />
        </div>
      ) : null}

      <FormField<WarehouseCreateInput> name="name" label="Название" placeholder="Primary" />
      <FormField<WarehouseCreateInput> name="description" label="Описание" placeholder="—" />

      <div className="space-y-2">
        <Label>Статус</Label>
        <Controller
          control={control}
          name="status"
          render={({ field }) => (
            <Select value={field.value ?? 'active'} onValueChange={field.onChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {WAREHOUSE_STATUSES.map((status) => (
                  <SelectItem key={status} value={status}>
                    {status}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        />
      </div>
    </>
  );
};
